import React from 'react';
import { alpha } from '@mui/system';
import { Box } from '@cp/ds/src/components/box';
import { useTheme } from '@cp/ds/src/hooks/useTheme';

const BORDER_RADIUS = '100px';
const OPACITY_1 = 0.2;
const OPACITY_2 = 0.4;
const OPACITY_3 = 0.6;

const StartRecordingButton: React.FC<{ onClick: () => void }> = ({ onClick }) => {
  const theme = useTheme();
  return (
    <Box
      onClick={onClick}
      sx={{
        p: 0.5,
        backgroundColor: alpha(theme.palette['brand pink'], OPACITY_1),
        mt: { xs: 3, md: 6.75 },
        mb: { xs: 3.25, md: 6 },
        borderRadius: BORDER_RADIUS,
      }}
    >
      <Box sx={{ p: 0.5, backgroundColor: alpha(theme.palette['brand pink'], OPACITY_2), borderRadius: BORDER_RADIUS }}>
        <Box sx={{ p: 0.5, backgroundColor: alpha(theme.palette['brand pink'], OPACITY_3), borderRadius: BORDER_RADIUS }}>
          <Box
            component="div"
            role="button"
            sx={{
              cursor: 'pointer',
              px: 5.875,
              py: 2,
              color: theme.palette.white,
              backgroundColor: theme.palette['brand pink'],
              borderRadius: BORDER_RADIUS,
            }}
            tabIndex={0}
          >
            Начать запись
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default StartRecordingButton;
